<template>
  <transition name="error" @enter="updateHeight">
    <div v-if="show" class="FieldError" :style="compStyle">
      <div class="wrapper" ref="$wrapper">
        <p class="message"><slot /></p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "FieldError",
  props: {
    show: { type: Boolean, required: true }
  },
  data() {
    return {
      h: null
    };
  },
  computed: {
    compStyle() {
      if (this.h !== null) {
        return { "--message-height": `${this.h}px` };
      }
    }
  },
  methods: {
    updateHeight() {
      this.h = this.$refs.$wrapper.clientHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/_variables.scss";

.message {
  color: $color-error;
  font-size: 14px;
  line-height: 1.25;
  padding: var(--error-message-gutter-top, 6px) 0
    var(--error-message-gutter-bottom, 0px);

  @media (min-width: $bootstrap-md) {
    font-size: 16px;
  }
}

.error-enter-active {
  animation-name: shakeError;
  animation-fill-mode: forwards;
  animation-duration: 0.4s;
  animation-timing-function: ease-in-out;
}

.error-leave-active {
  transition: opacity 0.4s ease-in-out, height 0.4s ease-in-out;
  height: var(--message-height);
}

.error-leave-to {
  opacity: 0;
  height: 0;
}

@keyframes shakeError {
  0% {
    transform: translateX(0);
    opacity: 0;
    height: 0;
  }
  15% {
    transform: translateX(0.375rem);
  }
  30% {
    transform: translateX(-0.375rem);
  }
  45% {
    transform: translateX(0.375rem);
  }
  60% {
    transform: translateX(-0.375rem);
  }
  75% {
    transform: translateX(0.375rem);
  }
  90% {
    transform: translateX(-0.375rem);
  }
  100% {
    transform: translateX(0);
    opacity: 1;
    height: var(--message-height);
  }
}
</style>
